export enum InheritType {
  XL = 1,
  AR,
}

export const inheritTypes = (): Record<InheritType, string> => ({
  [InheritType.AR]: 'AR',
  [InheritType.XL]: 'XL',
})
